import {api} from '@local/logics/common/api';
import type {EsTokenResponse} from '@local/api-interfaces/esToken';

export const apiEsToken = async () => {
  return await api.post<EsTokenResponse>('es-token');
};
